import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container px-4 mx-auto mt-10 border-t-8 border-blue-50 md:border-t-0" }
const _hoisted_2 = { class: "pb-10" }
const _hoisted_3 = {
  key: 0,
  class: "text-xl pb-4 font-bold"
}
const _hoisted_4 = {
  key: 1,
  class: "text-xl pb-4 font-bold"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Hide Instructions", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5 15l7-7 7 7"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Show Instructions", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm italic" }, "Groks can be about anything.*", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm italic" }, " Share your knowledge, insights, or questions. Learn in public to reinforce your learning and inspire others. Share your insights from papers, blogs, or books that you have read, podcasts that you have listened to, or conference talks that you have watched. Summarize your research or understanding in a subject. Be high-level or go in-depth. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm italic" }, "It's your grok. Share it!", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold uppercase" }, "* requirements:", -1)
const _hoisted_16 = { class: "list-square" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, "Maximum of 3 minutes in length.", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, "If you can, provide references to where people can learn more.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, "Include tags to help people find your Grok.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("li", null, "No false, inaccurate, or misleading content.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", null, "No advertising or promotional material.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, "No obscene, hateful, abusive, or otherwise offensive material.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, "Do not violate the privacy or intellectual property rights of any third party.", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Do not violate any other provisions of the ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Terms and Conditions")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(", or any applicable law or regulation. ")
const _hoisted_27 = { class: "grid" }
const _hoisted_28 = { class: "pt-8 pb-2 md:px-8 flex flex-col" }
const _hoisted_29 = {
  key: 0,
  class: "text-lg font-bold"
}
const _hoisted_30 = {
  key: 1,
  class: "text-lg font-bold"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Click here or drag and drop your video. Maximum length 3 minutes.", -1)
const _hoisted_32 = {
  for: "files",
  title: " ",
  class: "relative flex flex-col items-center px-4 py-6 rounded tracking-wide uppercase border border-gray-500 bg-gray-300 text-gray-800 bg-opacity-80 cursor-pointer hover:bg-gray-800 hover:bg-opacity-100 hover:text-gray-300"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-8 h-8",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" })
], -1)
const _hoisted_34 = {
  key: 0,
  class: "mt-2 text-base leading-normal"
}
const _hoisted_35 = {
  key: 1,
  class: "mt-2 italic text-base leading-normal"
}
const _hoisted_36 = {
  key: 2,
  class: "mt-2 italic text-base leading-normal"
}
const _hoisted_37 = {
  key: 3,
  class: "mt-2 text-base leading-normal"
}
const _hoisted_38 = ["required"]
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "pt-8 pb-2 md:px-8 flex flex-col" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold" }, "References", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 4v16m8-8H4"
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "pb-2.5 text-sm" }, "Where can people go to learn more?", -1)
const _hoisted_45 = ["aria-label"]
const _hoisted_46 = { class: "font-semibold text-md" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "flex flex-row items-center m-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "input.preview",
  class: "ml-2 block text-sm leading-5 text-gray-500"
}, " Preview before publish / peer-review ", -1)
const _hoisted_52 = { class: "flex flex-row items-center m-4" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "text-red-600" }
const _hoisted_55 = {
  key: 1,
  class: "text-red-700 text-sm"
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_TagInput = _resolveComponent("TagInput")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.grok)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Edit Your Grok"))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "What have you grokked today?")),
      (_ctx.showInstructions)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInstructions = false)),
            class: "ml-2 cursor-pointer inline has-tooltip relative"
          }, [
            _hoisted_5,
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: _normalizeClass(["h-6 w-6", 'w-5 h-5 text-blue-50 hover:text-gray-200 transition-colors duration-300 mt-0']),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2",
              "svg-inline": '',
              role: 'presentation',
              focusable: 'false',
              tabindex: '-1'
            }, _hoisted_7))
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInstructions = true)),
            class: "ml-2 cursor-pointer inline has-tooltip relative"
          }, [
            _hoisted_8,
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: _normalizeClass(["h-6 w-6", 'w-5 h-5 text-blue-50 hover:text-gray-200 transition-colors duration-300 mt-0']),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2",
              "svg-inline": '',
              role: 'presentation',
              focusable: 'false',
              tabindex: '-1'
            }, _hoisted_10))
          ])),
      (_ctx.showInstructions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("ul", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("li", null, [
                _hoisted_24,
                _createVNode(_component_router_link, { to: "/terms" }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _hoisted_26
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("form", {
      class: "w-full rounded md:border-8 border-blue-50",
      onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callUploadFile && _ctx.callUploadFile(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_28, [
            (_ctx.grok)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, "Upload A Different File?"))
              : (_openBlock(), _createElementBlock("p", _hoisted_30, "Upload Your Grok")),
            _hoisted_31,
            _createElementVNode("label", _hoisted_32, [
              _hoisted_33,
              (_ctx.fileName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.fileName), 1))
                : (_ctx.fileUploading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Uploading... Please wait"))
                  : (_ctx.fileError)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Video should not be longer than 3 minutes"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_37, "Select a file")),
              _createElementVNode("input", {
                id: "files",
                class: "absolute top-0 p-8 my-4 text-center border border-dotted border-gray-700 text-sm",
                type: "file",
                accept: "video/mp4,video/x-m4v,video/*",
                multiple: "false",
                required: _ctx.grok?.input.id,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateFile($event.target.files)))
              }, null, 40, _hoisted_38)
            ]),
            (_ctx.v$.input.s3OriginPath.$errors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.input.s3OriginPath.$errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: key,
                      class: "text-xs text-red-700"
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_base_input, {
            modelValue: _ctx.input.s3OriginPath,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.s3OriginPath) = $event)),
            label: "path",
            class: "sr-only",
            type: "hidden",
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validate()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_base_input, {
            modelValue: _ctx.input.title,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.input.title) = $event)),
            label: "Grok Title",
            class: "md:pl-8 md:pr-6",
            type: "text",
            errors: _ctx.v$.input.title.$errors,
            onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validate()))
          }, null, 8, ["modelValue", "errors"]),
          _createVNode(_component_base_textarea, {
            modelValue: _ctx.input.description,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.input.description) = $event)),
            label: "Grok Description",
            placeholder: "Description",
            class: "md:pl-8 md:pr-6",
            rows: "3",
            errors: _ctx.v$.input.description.$errors,
            onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validate()))
          }, null, 8, ["modelValue", "errors"]),
          _createVNode(_component_TagInput, {
            modelValue: _ctx.tags,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tags) = $event)),
            onTagsChanged: _ctx.validate,
            class: "md:pl-8 md:pr-6"
          }, null, 8, ["modelValue", "onTagsChanged"])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", null, [
              _hoisted_41,
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["h-6 w-6", 'inline text-green-600 hover:text-gray-700 transition-colors duration-300 -mt-1 pl-2 cursor-pointer']),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2",
                "svg-inline": '',
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addField())),
                role: 'presentation',
                focusable: 'false',
                tabindex: '-1'
              }, _hoisted_43))
            ]),
            _hoisted_44,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.references, (input, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: input.id
              }, [
                _createElementVNode("div", {
                  class: "relative w-auto whitespace-nowrap overflow-ellipsis",
                  "aria-label": input.url
                }, [
                  _createElementVNode("span", _hoisted_46, "Reference " + _toDisplayString(index + 1), 1),
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(["h-6 w-6", 'inline text-red-600 hover:text-gray-700 transition-colors duration-300 -mt-1 pl-2 cursor-pointer']),
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "svg-inline": '',
                    onClick: ($event: any) => (_ctx.removeField(index)),
                    role: 'presentation',
                    focusable: 'false',
                    tabindex: '-1'
                  }, _hoisted_49, 8, _hoisted_47)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_base_input, {
                      modelValue: input.url,
                      "onUpdate:modelValue": ($event: any) => ((input.url) = $event),
                      label: `Reference ${index + 1} URL`,
                      type: "text",
                      class: "md:pl-8",
                      onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validate()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                  ]),
                  _createVNode(_component_base_input, {
                    modelValue: input.description,
                    "onUpdate:modelValue": ($event: any) => ((input.description) = $event),
                    label: `Reference ${index + 1} Title`,
                    type: "text",
                    class: "md:pl-8",
                    onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validate()))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                ], 8, _hoisted_45)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _withDirectives(_createElementVNode("input", {
          id: "preview",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.input.preview) = $event)),
          type: "checkbox",
          class: "form-checkbox h-4 w-4 transition duration-150 ease-in-out"
        }, null, 512), [
          [_vModelCheckbox, _ctx.input.preview]
        ]),
        _hoisted_51
      ]),
      _createElementVNode("div", _hoisted_52, [
        (_ctx.createUploadErrors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createUploadErrors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error[0]
                }, [
                  _createElementVNode("p", _hoisted_54, _toDisplayString(error), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.grok && !_ctx.user.verified && !_ctx.grok.draft)
          ? (_openBlock(), _createElementBlock("p", _hoisted_55, " The review process will restart when you make an edit. "))
          : _createCommentVNode("", true),
        (_ctx.grok)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn-primary ml-auto",
              disabled: _ctx.isDisabled,
              onClick: [
                _cache[14] || (_cache[14] = ($event: any) => (_ctx.callUpdateGrok())),
                _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.isDisabled && _ctx.isDisabled(...args)), ["prevent"]))
              ]
            }, " Edit ", 8, _hoisted_56))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "btn btn-primary ml-auto",
              disabled: _ctx.isDisabled,
              onClick: [
                _cache[16] || (_cache[16] = ($event: any) => (_ctx.callUploadFile())),
                _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.isDisabled && _ctx.isDisabled(...args)), ["prevent"]))
              ]
            }, " Submit ", 8, _hoisted_57))
      ])
    ], 32)
  ]))
}